module.exports = __webpack_public_path__ + "static/media/quality.f93436ac.svg";